(function () {
    var app = angular.module('app');

    /**
     * Service used to deliver data in case optimizely does not manage to deliver the variation data in time
     */
    app.service('optimizelyFallbackData', function () {

        var fallbackData = {
  "About": "AutomatedAccounting.IO is run by Clerk.AI OÜ. We build and promote no-bullshit accounting software for entrepreneurs that evaluate freedom over everything else, such as digital nomads and lifehackers. These services addresses vital pain points that we personally have experienced during the last 13 years of attempting to be free from bureaucracy and 9-5 schedules while working remotely. The team consists of one fierce founder and his network of independent contractors that have been building software and companies together since 2007.",
  "Button text": "Monthly plans from $9",
  "Description": "Avoid the boring and repetitive task of moving numbers around manually within accounting software",
  "Description ": null,
  "Description Chars (80)": 0,
  "Final URL": null,
  "Final URL Base": null,
  "Headline (60 chars)": "Accounting is not rocket science",
  "Headline 1": null,
  "Headline 1 Chars (30)": 0,
  "Headline 2": null,
  "Headline 2 Chars (30=": 0,
  "Keywords": null,
  "One-liner": "Automated accounting for digital nomads",
  "Price": null,
  "Problem we are solving": "Avoid the boring and repetitive task of moving numbers around manually within accounting software",
  "Product Name (40 chars)": "automatedaccounting.io",
  "Service / Ad Group": "automatedaccounting.io",
  "Step 1 headline": "1. Upload the accounting prep-work",
  "Step 1 text": "Or import it from accountingprepwork.com. (A bank statement or some invoice data is enough to try it out)",
  "Step 2 headline": "2. Press \"Generate\"",
  "Step 2 text": "Our software will guess ledger entry types and and accounts",
  "Step 3 headline": "3. Iterate until satisfied",
  "Step 3 text": "Make corrections and customizations specific to your business. Rinse and repeat until you are done",
  "Supporting text (150 chars)": "It is just really, sincerely and utterly boring to do by hand. If you have a bank statement and some basic knowledge of accounting, we can automate it",
  "Testimonial (X chars)": "Finally I don't have to manually calculate VAT amounts and move around numbers from Excel to my accounting software for hours and hours",
  "Testimonial author (X chars)": "Fredrik Wollsén",
  "Visible URL Path": "/",
  "Why we are solving this problem": "Because we don't want anyone to experience accounting-agony",
  "account activation banner": "The basic workflow is shown below.",
  "account activation button text": "Request invite now by chat",
  "account activation heading": "Thank you for signing up!",
  "account activation info": "We are in private beta and are thrilled to get you on board!<br/>Tell us a bit about what you hope to achieve with AutomatedAccounting.IO and we will invite you to the beta:",
  "account activation subtext": "We will get back to you as soon as we have your beta account ready",
  "background image": null,
  "background video mp4": "(no video)",
  "background video ogg": "(no video)",
  "background video poster": "(no video)",
  "background video webm": "(no video)",
  "basic colors - @blue (success color)": null,
  "basic colors - @dark-gray (default color)": null,
  "basic colors - @divi (primary divi theme color)": null,
  "basic colors - @lazur (info color)": null,
  "basic colors - @navy (primary color)": null,
  "basic colors - @red (danger color)": null,
  "basic colors - @white (white)": null,
  "basic colors - @yellow (warning color)": null,
  "border radius for buttons - @btn-border-radius": null,
  "boxed layout width - @boxed-backgound": null,
  "boxed layout width - @boxed-width": null,
  "center plan description": null,
  "center plan features markup": null,
  "center plan monthly price": null,
  "center plan name": null,
  "experiment_ref": "aaio_2nd",
  "faq how much does it cost - answer": "<p>Straightforward monthly pricing without limits in regards to amount of transactions to handle every month: 39€/month</p>",
  "faq what can i expect to get help with - answer": "Avoid the boring and repetitive task of moving numbers around manually within accounting software",
  "faq who is behind - answer": "AutomatedAccounting.IO is run by Clerk.AI OÜ. We build and promote no-bullshit accounting software for entrepreneurs that evaluate freedom over everything else, such as digital nomads and lifehackers. These services addresses vital pain points that we personally have experienced during the last 13 years of attempting to be free from bureaucracy and 9-5 schedules while working remotely. The team consists of one fierce founder and his network of independent contractors that have been building software and companies together since 2007.",
  "faq why did you create - answer": "Because we don't want anyone to experience accounting-agony",
  "ibox colors - @border-color (ibox border)": null,
  "ibox colors - @ibox-content-bg (ibox background content)": null,
  "ibox colors - @ibox-title-bg (ibox background header)": null,
  "info 1 class": "fa-paper-plane-o",
  "info 1 heading": "1. Upload source information",
  "info 1 shown": "yes",
  "info 1 subtext": null,
  "info 10 class": null,
  "info 10 heading": null,
  "info 10 shown": "no",
  "info 10 subtext": null,
  "info 11 class": null,
  "info 11 heading": null,
  "info 11 shown": "no",
  "info 11 subtext": null,
  "info 12 class": null,
  "info 12 heading": null,
  "info 12 shown": "no",
  "info 12 subtext": null,
  "info 13 class": null,
  "info 13 heading": null,
  "info 13 shown": "no",
  "info 13 subtext": null,
  "info 14 class": null,
  "info 14 heading": null,
  "info 14 shown": "no",
  "info 14 subtext": null,
  "info 15 class": null,
  "info 15 heading": null,
  "info 15 shown": "no",
  "info 15 subtext": null,
  "info 16 class": null,
  "info 16 heading": null,
  "info 16 shown": "no",
  "info 16 subtext": null,
  "info 17 class": null,
  "info 17 heading": null,
  "info 17 shown": "no",
  "info 17 subtext": null,
  "info 18 class": null,
  "info 18 heading": null,
  "info 18 shown": "no",
  "info 18 subtext": null,
  "info 19 class": null,
  "info 19 heading": null,
  "info 19 shown": "no",
  "info 19 subtext": null,
  "info 2 class": "fa-space-shuttle",
  "info 2 heading": "2. Press \"Generate\"",
  "info 2 shown": "yes",
  "info 2 subtext": null,
  "info 20 class": null,
  "info 20 heading": null,
  "info 20 shown": "no",
  "info 20 subtext": null,
  "info 3 class": "fa-black-tie",
  "info 3 heading": "3. Accounting is generated instantly",
  "info 3 shown": "yes",
  "info 3 subtext": null,
  "info 4 class": "fa-diamond",
  "info 4 heading": "4. Refine until satisfied",
  "info 4 shown": "yes",
  "info 4 subtext": null,
  "info 5 class": null,
  "info 5 heading": null,
  "info 5 shown": "no",
  "info 5 subtext": null,
  "info 6 class": null,
  "info 6 heading": null,
  "info 6 shown": "no",
  "info 6 subtext": null,
  "info 7 class": null,
  "info 7 heading": null,
  "info 7 shown": "no",
  "info 7 subtext": null,
  "info 8 class": null,
  "info 8 heading": null,
  "info 8 shown": "no",
  "info 8 subtext": null,
  "info 9 class": null,
  "info 9 heading": null,
  "info 9 shown": "no",
  "info 9 subtext": null,
  "inforow 1 shown": "yes",
  "inforow 2 shown": "no",
  "inforow 3 shown": "no",
  "inforow 4 shown": "no",
  "inforow 5 shown": "no",
  "intro section shown": "no",
  "left plan description": null,
  "left plan features markup": null,
  "left plan monthly price": null,
  "left plan name": null,
  "main banner": "Currently in private beta for entrepreneurs based in Sweden",
  "main button text": "Sign up for early access",
  "main heading": "Automated Accounting",
  "main info": "Upload bank statements, invoice data and receipts and our software generates the corresponding accounting",
  "main plan description": null,
  "main plan header": null,
  "main plan left subheader": null,
  "main plan left subtext": null,
  "main plan monthly price": null,
  "main plan name": null,
  "main plan right subheader": null,
  "main plan right subtext": null,
  "main subtext": null,
  "mo center plan description": null,
  "mo center plan features markup": null,
  "mo center plan name": null,
  "mo center plan price": null,
  "mo center plan unit": null,
  "mo left plan description": null,
  "mo left plan features markup": null,
  "mo left plan name": null,
  "mo left plan price": null,
  "mo left plan unit": null,
  "mo right plan description": null,
  "mo right plan features markup": null,
  "mo right plan name": null,
  "mo right plan price": null,
  "mo right plan unit": null,
  "more options header": null,
  "more options subtext": null,
  "navigation - @nav-bg": null,
  "navigation - @nav-profil-pattern": null,
  "navigation - @nav-text-color": null,
  "pricing header": null,
  "pricing subtext": null,
  "product name": "automatedaccounting.io",
  "right plan description": null,
  "right plan features markup": null,
  "right plan monthly price": null,
  "right plan name": null,
  "sidebar - @sidebar-active": null,
  "sidebar - @sidebar-color": null,
  "sidebar - @sidebar-width": null,
  "sign up button text": null,
  "testimonial 1": "\"Finally I don't have to manually calculate VAT amounts and move around numbers from Excel to my accounting software for hours and hours\" - Fredrik Wollsén",
  "testimonial 2": "\"\"",
  "testimonial 3": "\"\"",
  "theme": null,
  "use-cases section shown": "no",
  "utm_x": null,
  "utm_y": null,
  "utm_z": null,
  "variation_ref": "var_201711_a",
  "various colors - @gray (background wrapper color)": null,
  "various colors - @label-badget-color": null,
  "various colors - @light-gray (default label, badget)": null,
  "various colors - @navbar-active-color": null,
  "various colors - @navbar-bg-color": null,
  "various colors - @text-color (body text)": null,
  "video header": null,
  "video href": null,
  "video section shown": "no"
}
;
        return fallbackData;

    });

})();



// WEBPACK FOOTER //
// .-dna/app/scripts/optimizely-fallback-data.js